import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ClassYearsApi from '../generated/api/ClassYears';

export default (service: Servicelayer) => ({
  ...ClassYearsApi(service),

  // Add custom calls here

});
